import React from 'react';

import {makeBorderClass} from './Input';
import ErrorMessage from './ErrorMessage';

type TextAreaProps = {
  id?: string;
  value?: string;
  errorMessage?: string;
  className?: string;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onBlur?: (event?: React.FocusEvent<HTMLTextAreaElement>) => void;
  disabled?: boolean;
  maxLength?: number;
};

const TextArea = ({
  className,
  errorMessage,
  value,
  ...props
}: TextAreaProps) => (
  <>
    <textarea
      className={`w-full h-24 p-4 ${makeBorderClass(
        errorMessage
      )} ${className}`}
      value={value || ''}
      {...props}
    />
    <ErrorMessage>{errorMessage}</ErrorMessage>
  </>
);

export default TextArea;
